import { PrimitiveAtom } from "jotai";
import {
  examplePublishAtom,
  IPublishState,
  momentPublishAtom,
  landmarkPublishAtom,
  settingsPublishAtom,
} from "./atoms";

interface IPublishGroup {
  models: string[];
  singleItems: string[];
  atom: PrimitiveAtom<IPublishState>;
}

interface IPublishGroups {
  [key: string]: IPublishGroup;
}

export const publishGroups: IPublishGroups = {
  moment: {
    models: ["moment", "media"],
    singleItems: [],
    atom: momentPublishAtom,
  },
  landmark: {
    models: ["landmark", "media"],
    singleItems: [],
    atom: landmarkPublishAtom,
  },
  settings: {
    models: [],
    singleItems: ["settings", "topics", "place"],
    atom: settingsPublishAtom,
  },
};
